// Going to be in the backend

export const statesInNigeria = [
  {
    code: "FC",
    name: "Abuja",
    capital: "",
    latitude: "8.831122799397733",
    longitude: "7.172467300000001",
    lgas: ["Abuja", "Kwali", "Kuje", "Gwagwalada", "Bwari", "Abaji"],
  },

  {
    code: "AB",
    name: "Abia",
    capital: "Umuahia",
    latitude: "5.45409529947607",
    longitude: "7.5153071",
    lgas: [
      "Aba North",
      "Aba South",
      "Arochukwu",
      "Bende",
      "Ikawuno",
      "Ikwuano",
      "Isiala-Ngwa North",
      "Isiala-Ngwa South",
      "Isuikwuato",
      "Umu Nneochi",
      "Obi Ngwa",
      "Obioma Ngwa",
      "Ohafia",
      "Ohaozara",
      "Osisioma",
      "Ugwunagbo",
      "Ukwa West",
      "Ukwa East",
      "Umuahia North",
      "Umuahia South",
    ],
  },

  {
    code: "AD",
    name: "Adamawa",
    capital: "Yola",
    latitude: "9.512977199417053",
    longitude: "12.388188699999999",
    lgas: [
      "Demsa",
      "Fufore",
      "Ganye",
      "Girei",
      "Gombi",
      "Guyuk",
      "Hong",
      "Jada",
      "Lamurde",
      "Madagali",
      "Maiha",
      "Mayo-Belwa",
      "Michika",
      "Mubi-North",
      "Mubi-South",
      "Numan",
      "Shelleng",
      "Song",
      "Toungo",
      "Yola North",
      "Yola South",
    ],
  },

  {
    code: "AK",
    name: "Akwa Ibom",
    capital: "Uyo",
    latitude: "4.940863799511036",
    longitude: "7.8412267",
    lgas: [
      "Abak",
      "Eastern-Obolo",
      "Eket",
      "Esit-Eket",
      "Essien-Udim",
      "Etim-Ekpo",
      "Etinan",
      "Ibeno",
      "Ibesikpo-Asutan",
      "Ibiono-Ibom",
      "Ika",
      "Ikono",
      "Ikot-Abasi",
      "Ikot-Ekpene",
      "Ini",
      "Itu",
      "Mbo",
      "Mkpat-Enin",
      "Nsit-Atai",
      "Nsit-Ibom",
      "Nsit-Ubium",
      "Obot-Akara",
      "Okobo",
      "Onna",
      "Oron",
      "Oruk Anam",
      "Udung-Uko",
      "Ukanafun",
      "Urue-Offong/Oruko",
      "Uruan",
      "Uyo",
    ],
  },

  {
    code: "AN",
    name: "Anambra",
    capital: "Awka",
    latitude: "6.2183135994341985",
    longitude: "6.9531842",
    lgas: [
      "Aguata",
      "Anambra East",
      "Anambra West",
      "Anaocha",
      "Awka North",
      "Awka South",
      "Ayamelum",
      "Dunukofia",
      "Ekwusigo",
      "Idemili-North",
      "Idemili-South",
      "Ihiala",
      "Njikoka",
      "Nnewi-North",
      "Nnewi-South",
      "Ogbaru",
      "Onitsha-North",
      "Onitsha-South",
      "Orumba-North",
      "Orumba-South",
    ],
  },

  {
    code: "BA",
    name: "Bauchi",
    capital: "Bauchi",
    latitude: "10.622828399473097",
    longitude: "10.028775399999999",
    lgas: [
      "Alkaleri",
      "Bauchi",
      "Bogoro",
      "Damban",
      "Darazo",
      "Dass",
      "Gamawa",
      "Ganjuwa",
      "Giade",
      "Itas Gadau",
      "Jama'Are",
      "Katagum",
      "Kirfi",
      "Misau",
      "Ningi",
      "Shira",
      "Tafawa-Balewa",
      "Toro",
      "Warji",
      "Zaki",
    ],
  },

  {
    code: "BY",
    name: "Bayelsa",
    capital: "Yenagoa",
    latitude: "4.762978599524332",
    longitude: "6.028898",
    lgas: [
      "Brass",
      "Ekeremor",
      "Kolokuma Opokuma",
      "Nembe",
      "Ogbia",
      "Sagbama",
      "Southern-Ijaw",
      "Yenagoa",
    ],
  },

  {
    code: "BE",
    name: "Benue",
    capital: "Makurdi",
    latitude: "7.35057469939717",
    longitude: "8.777287699999999",
    lgas: [
      "Ado",
      "Agatu",
      "Apa",
      "Buruku",
      "Gboko",
      "Guma",
      "Gwer-East",
      "Gwer-West",
      "Katsina-Ala",
      "Konshisha",
      "Kwande",
      "Logo",
      "Makurdi",
      "Ogbadibo",
      "Ohimini",
      "Oju",
      "Okpokwu",
      "Otukpo",
      "Tarka",
      "Ukum",
      "Ushongo",
      "Vandeikya",
    ],
  },

  {
    code: "BO",
    name: "Borno",
    capital: "Maiduguri",
    latitude: "12.18753919959776",
    longitude: "13.308003399999999",
    lgas: [
      "Abadam",
      "Askira-Uba",
      "Bama",
      "Bayo",
      "Biu",
      "Chibok",
      "Damboa",
      "Dikwa",
      "Gubio",
      "Guzamala",
      "Gwoza",
      "Hawul",
      "Jere",
      "Kaga",
      "Kala Balge",
      "Konduga",
      "Kukawa",
      "Kwaya-Kusar",
      "Mafa",
      "Magumeri",
      "Maiduguri",
      "Marte",
      "Mobbar",
      "Monguno",
      "Ngala",
      "Nganzai",
      "Shani",
    ],
  },

  {
    code: "CR",
    name: "Cross River",
    capital: "Calabar",
    latitude: "5.867196599451846",
    longitude: "8.5204774",
    lgas: [
      "Abi",
      "Akamkpa",
      "Akpabuyo",
      "Bakassi",
      "Bekwarra",
      "Biase",
      "Boki",
      "Calabar-Municipal",
      "Calabar-South",
      "Etung",
      "Ikom",
      "Obanliku",
      "Obubra",
      "Obudu",
      "Odukpani",
      "Ogoja",
      "Yakurr",
      "Yala",
    ],
  },

  {
    code: "DE",
    name: "Delta",
    capital: "Asaba",
    latitude: "5.527306099471514",
    longitude: "6.178416699999999",
    lgas: [
      "Aniocha North",
      "Aniocha-North",
      "Aniocha-South",
      "Bomadi",
      "Burutu",
      "Ethiope-East",
      "Ethiope-West",
      "Ika-North-East",
      "Ika-South",
      "Isoko-North",
      "Isoko-South",
      "Ndokwa-East",
      "Ndokwa-West",
      "Okpe",
      "Oshimili-North",
      "Oshimili-South",
      "Patani",
      "Sapele",
      "Udu",
      "Ughelli-North",
      "Ughelli-South",
      "Ukwuani",
      "Uvwie",
      "Warri South-West",
      "Warri North",
      "Warri South",
    ],
  },

  {
    code: "EB",
    name: "Ebonyi",
    capital: "Abakaliki",
    latitude: "6.199691799435065",
    longitude: "8.0348906",
    lgas: [
      "Abakaliki",
      "Afikpo-North",
      "Afikpo South (Edda)",
      "Ebonyi",
      "Ezza-North",
      "Ezza-South",
      "Ikwo",
      "Ishielu",
      "Ivo",
      "Izzi",
      "Ohaukwu",
      "Onicha",
    ],
  },

  {
    code: "ED",
    name: "Edo",
    capital: "Benin City",
    latitude: "6.607657499417959",
    longitude: "5.9722713",
    lgas: [
      "Akoko Edo",
      "Egor",
      "Esan-Central",
      "Esan-North-East",
      "Esan-South-East",
      "Esan-West",
      "Etsako-Central",
      "Etsako-East",
      "Etsako-West",
      "Igueben",
      "Ikpoba-Okha",
      "Oredo",
      "Orhionmwon",
      "Ovia-North-East",
      "Ovia-South-West",
      "Owan East",
      "Owan-West",
      "Uhunmwonde",
    ],
  },

  {
    code: "EK",
    name: "Ekiti",
    capital: "Ado-Ekiti",
    latitude: "7.736890999391845",
    longitude: "5.2738326",
    lgas: [
      "Ado-Ekiti",
      "Efon",
      "Ekiti-East",
      "Ekiti-South-West",
      "Ekiti-West",
      "Emure",
      "Gbonyin",
      "Ido-Osi",
      "Ijero",
      "Ikere",
      "Ikole",
      "Ilejemeje",
      "Irepodun Ifelodun",
      "Ise-Orun",
      "Moba",
      "Oye",
    ],
  },

  {
    code: "EN",
    name: "Enugu",
    capital: "Enugu",
    latitude: "6.553609399419997",
    longitude: "7.4143061",
    lgas: [
      "Aninri",
      "Awgu",
      "Enugu-East",
      "Enugu-North",
      "Enugu-South",
      "Ezeagu",
      "Igbo-Etiti",
      "Igbo-Eze-North",
      "Igbo-Eze-South",
      "Isi-Uzo",
      "Nkanu-East",
      "Nkanu-West",
      "Nsukka",
      "Oji-River",
      "Udenu",
      "Udi",
      "Uzo-Uwani",
    ],
  },

  {
    code: "GO",
    name: "Gombe",
    capital: "Gombe",
    latitude: "10.383009999458512",
    longitude: "11.206567",
    lgas: [
      "Akko",
      "Balanga",
      "Billiri",
      "Dukku",
      "Funakaye",
      "Gombe",
      "Kaltungo",
      "Kwami",
      "Nafada",
      "Shongom",
      "Yamaltu Deba",
    ],
  },

  {
    code: "IM",
    name: "Imo",
    capital: "Owerri",
    latitude: "5.585945599467946",
    longitude: "7.0669651",
    lgas: [
      "Aboh-Mbaise",
      "Ahiazu-Mbaise",
      "Ehime-Mbano",
      "Ezinihitte",
      "Ideato-North",
      "Ideato-South",
      "Ihitte Uboma",
      "Ikeduru",
      "Isiala-Mbano",
      "Isu",
      "Mbaitoli",
      "Ngor-Okpala",
      "Njaba",
      "Nkwerre",
      "Nwangele",
      "Obowo",
      "Oguta",
      "Ohaji-Egbema",
      "Okigwe",
      "Onuimo",
      "Orlu",
      "Orsu",
      "Oru-East",
      "Oru-West",
      "Owerri-Municipal",
      "Owerri-North",
      "Owerri-West",
    ],
  },

  {
    code: "JI",
    name: "Jigawa",
    capital: "Dutse",
    latitude: "12.325236199610885",
    longitude: "9.510329599999999",
    lgas: [
      "Auyo",
      "Babura",
      "Biriniwa",
      "Birnin-Kudu",
      "Buji",
      "Dutse",
      "Gagarawa",
      "Garki",
      "Gumel",
      "Guri",
      "Gwaram",
      "Gwiwa",
      "Hadejia",
      "Jahun",
      "Kafin-Hausa",
      "Kaugama",
      "Kazaure",
      "Kiri kasama",
      "Maigatari",
      "Malam Madori",
      "Miga",
      "Ringim",
      "Roni",
      "Sule-Tankarkar",
      "Taura",
      "Yankwashi",
    ],
  },

  {
    code: "KD",
    name: "Kaduna",
    capital: "Kaduna",
    latitude: "10.382531799458487",
    longitude: "7.853322600000001",
    lgas: [
      "Birnin-Gwari",
      "Chikun",
      "Giwa",
      "Igabi",
      "Ikara",
      "Jaba",
      "Jema'A",
      "Kachia",
      "Kaduna-North",
      "Kaduna-South",
      "Kagarko",
      "Kajuru",
      "Kaura",
      "Kauru",
      "Kubau",
      "Kudan",
      "Lere",
      "Makarfi",
      "Sabon-Gari",
      "Sanga",
      "Soba",
      "Zangon-Kataf",
      "Zaria",
    ],
  },

  {
    code: "KN",
    name: "Kano",
    capital: "Kano",
    latitude: "11.894838899570903",
    longitude: "8.5364136",
    lgas: [
      "Ajingi",
      "Albasu",
      "Bagwai",
      "Bebeji",
      "Bichi",
      "Bunkure",
      "Dala",
      "Dambatta",
      "Dawakin-Kudu",
      "Dawakin-Tofa",
      "Doguwa",
      "Fagge",
      "Gabasawa",
      "Garko",
      "Garun-Mallam",
      "Gaya",
      "Gezawa",
      "Gwale",
      "Gwarzo",
      "Kabo",
      "Kano-Municipal",
      "Karaye",
      "Kibiya",
      "Kiru",
      "Kumbotso",
      "Kunchi",
      "Kura",
      "Madobi",
      "Makoda",
      "Minjibir",
      "Nasarawa",
      "Rano",
      "Rimin-Gado",
      "Rogo",
      "Shanono",
      "Sumaila",
      "Takai",
      "Tarauni",
      "Tofa",
      "Tsanyawa",
      "Tudun-Wada",
      "Ungogo",
      "Warawa",
      "Wudil",
    ],
  },

  {
    code: "KT",
    name: "Katsina",
    capital: "Kastina",
    latitude: "12.563082499634245",
    longitude: "7.6207063",
    lgas: [
      "Bakori",
      "Batagarawa",
      "Batsari",
      "Baure",
      "Bindawa",
      "Charanchi",
      "Dan-Musa",
      "Dandume",
      "Danja",
      "Daura",
      "Dutsi",
      "Dutsin-Ma",
      "Faskari",
      "Funtua",
      "Ingawa",
      "Jibia",
      "Kafur",
      "Kaita",
      "Kankara",
      "Kankia",
      "Katsina",
      "Kurfi",
      "Kusada",
      "Mai-Adua",
      "Malumfashi",
      "Mani",
      "Mashi",
      "Matazu",
      "Musawa",
      "Rimi",
      "Sabuwa",
      "Safana",
      "Sandamu",
      "Zango",
    ],
  },

  {
    code: "KE",
    name: "Kebbi",
    capital: "Birnin-Kebbi",
    latitude: "11.416757399530335",
    longitude: "4.107454499999999",
    lgas: [
      "Aleiro",
      "Arewa-Dandi",
      "Argungu",
      "Augie",
      "Bagudo",
      "Birnin-Kebbi",
      "Bunza",
      "Dandi",
      "Fakai",
      "Gwandu",
      "Jega",
      "Kalgo",
      "Koko-Besse",
      "Maiyama",
      "Ngaski",
      "Sakaba",
      "Shanga",
      "Suru",
      "Wasagu/Danko",
      "Yauri",
      "Zuru",
    ],
  },

  {
    code: "KO",
    name: "Kogi",
    capital: "Lokoja",
    latitude: "7.79496019939138",
    longitude: "6.686866899999999",
    lgas: [
      "Adavi",
      "Ajaokuta",
      "Ankpa",
      "Dekina",
      "Ibaji",
      "Idah",
      "Igalamela-Odolu",
      "Ijumu",
      "Kabba Bunu",
      "Kogi",
      "Lokoja",
      "Mopa-Muro",
      "Ofu",
      "Ogori Magongo",
      "Okehi",
      "Okene",
      "Olamaboro",
      "Omala",
      "Oyi",
      "Yagba-East",
      "Yagba-West",
    ],
  },

  {
    code: "KW",
    name: "Kwara",
    capital: "Ilorin",
    latitude: "8.836789099397848",
    longitude: "4.668848699999999",
    lgas: [
      "Asa",
      "Baruten",
      "Edu",
      "Ekiti (Araromi/Opin)",
      "Ilorin-East",
      "Ilorin-South",
      "Ilorin-West",
      "Isin",
      "Kaiama",
      "Moro",
      "Offa",
      "Oke-Ero",
      "Oyun",
      "Pategi",
    ],
  },

  {
    code: "LA",
    name: "Lagos",
    capital: "Ikeja",
    latitude: "6.526903299421034",
    longitude: "3.5774005",
    lgas: [
      "Agege",
      "Ajeromi-Ifelodun",
      "Alimosho",
      "Amuwo-Odofin",
      "Apapa",
      "Badagry",
      "Epe",
      "Eti-Osa",
      "Ibeju-Lekki",
      "Ifako-Ijaiye",
      "Ikeja",
      "Ikorodu",
      "Kosofe",
      "Lagos-Island",
      "Lagos-Mainland",
      "Mushin",
      "Ojo",
      "Oshodi-Isolo",
      "Shomolu",
      "Surulere",
      "Yewa-South",
    ],
  },

  {
    code: "NA",
    name: "Nassarawa",
    capital: "Lafia",
    latitude: "8.438786799392046",
    longitude: "8.238284899999998",
    lgas: [
      "Akwanga",
      "Awe",
      "Doma",
      "Karu",
      "Keana",
      "Keffi",
      "Kokona",
      "Lafia",
      "Nasarawa",
      "Nasarawa-Eggon",
      "Obi",
      "Wamba",
      "Toto",
    ],
  },

  {
    code: "NI",
    name: "Niger",
    capital: "Minna",
    latitude: "9.932608299434758",
    longitude: "5.651108799999999",
    lgas: [
      "Agaie",
      "Agwara",
      "Bida",
      "Borgu",
      "Bosso",
      "Chanchaga",
      "Edati",
      "Gbako",
      "Gurara",
      "Katcha",
      "Kontagora",
      "Lapai",
      "Lavun",
      "Magama",
      "Mariga",
      "Mashegu",
      "Mokwa",
      "Moya",
      "Paikoro",
      "Rafi",
      "Rijau",
      "Shiroro",
      "Suleja",
      "Tafa",
      "Wushishi",
    ],
  },

  {
    code: "OG",
    name: "Ogun",
    capital: "Abeokuta",
    latitude: "6.978858199405861",
    longitude: "3.4389293",
    lgas: [
      "Abeokuta-North",
      "Abeokuta-South",
      "Ado-Odo Ota",
      "Ewekoro",
      "Ifo",
      "Ijebu-East",
      "Ijebu-North",
      "Ijebu-North-East",
      "Ijebu-Ode",
      "Ikenne",
      "Imeko-Afon",
      "Ipokia",
      "Obafemi-Owode",
      "Odeda",
      "Odogbolu",
      "Ogun-Waterside",
      "Remo-North",
      "Shagamu",
      "Yewa North",
    ],
  },

  {
    code: "ON",
    name: "Ondo",
    capital: "Akure",
    latitude: "7.0209685994047035",
    longitude: "5.0567477",
    lgas: [
      "Akoko North-East",
      "Akoko North-West",
      "Akoko South-West",
      "Akoko South-East",
      "Akure-North",
      "Akure-South",
      "Ese-Odo",
      "Idanre",
      "Ifedore",
      "Ilaje",
      "Ile-Oluji-Okeigbo",
      "Irele",
      "Odigbo",
      "Okitipupa",
      "Ondo West",
      "Ondo-East",
      "Ose",
      "Owo",
    ],
  },

  {
    code: "OS",
    name: "Osun",
    capital: "Osogbo",
    latitude: "7.548404699393967",
    longitude: "4.497830700000001",
    lgas: [
      "Atakumosa West",
      "Atakumosa East",
      "Ayedaade",
      "Ayedire",
      "Boluwaduro",
      "Boripe",
      "Ede South",
      "Ede North",
      "Egbedore",
      "Ejigbo",
      "Ife North",
      "Ife South",
      "Ife-Central",
      "Ife-East",
      "Ifelodun",
      "Ila",
      "Ilesa-East",
      "Ilesa-West",
      "Irepodun",
      "Irewole",
      "Isokan",
      "Iwo",
      "Obokun",
      "Odo-Otin",
      "Ola Oluwa",
      "Olorunda",
      "Oriade",
      "Orolu",
      "Osogbo",
    ],
  },

  {
    code: "OY",
    name: "Oyo",
    capital: "Ibadan",
    latitude: "8.215124899390593",
    longitude: "3.5642896999999993",
    lgas: [
      "Afijio",
      "Akinyele",
      "Atiba",
      "Atisbo",
      "Egbeda",
      "Ibadan North",
      "Ibadan North-East",
      "Ibadan North-West",
      "Ibadan South-East",
      "Ibadan South-West",
      "Ibarapa-Central",
      "Ibarapa-East",
      "Ibarapa-North",
      "Ido",
      "Ifedayo",
      "Irepo",
      "Iseyin",
      "Itesiwaju",
      "Iwajowa",
      "Kajola",
      "Lagelu",
      "Ogo-Oluwa",
      "Ogbomosho-North",
      "Ogbomosho-South",
      "Olorunsogo",
      "Oluyole",
      "Ona-Ara",
      "Orelope",
      "Ori-Ire",
      "Oyo-West",
      "Oyo-East",
      "Saki-East",
      "Saki-West",
      "Surulere",
    ],
  },

  {
    code: "PL",
    name: "Plateau",
    capital: "Jos",
    latitude: "9.058344599402849",
    longitude: "9.6826289",
    lgas: [
      "Barkin-Ladi",
      "Bassa",
      "Bokkos",
      "Jos-East",
      "Jos-North",
      "Jos-South",
      "Kanam",
      "Kanke",
      "Langtang-North",
      "Langtang-South",
      "Mangu",
      "Mikang",
      "Pankshin",
      "Qua'an Pan",
      "Riyom",
      "Shendam",
      "Wase",
    ],
  },

  {
    code: "RI",
    name: "Rivers",
    capital: "Port-Harcourt",
    latitude: "4.841602799518385",
    longitude: "6.8604088",
    lgas: [
      "Abua Odual",
      "Ahoada-East",
      "Ahoada-West",
      "Akuku Toru",
      "Andoni",
      "Asari-Toru",
      "Bonny",
      "Degema",
      "Eleme",
      "Emuoha",
      "Etche",
      "Gokana",
      "Ikwerre",
      "Khana",
      "Obio Akpor",
      "Ogba-Egbema-Ndoni",
      "Ogba Egbema Ndoni",
      "Ogu Bolo",
      "Okrika",
      "Omuma",
      "Opobo Nkoro",
      "Oyigbo",
      "Port-Harcourt",
      "Tai",
    ],
  },

  {
    code: "SO",
    name: "Sokoto",
    capital: "Sokoto",
    latitude: "13.061119499685718",
    longitude: "5.3152203",
    lgas: [
      "Binji",
      "Bodinga",
      "Dange-Shuni",
      "Gada",
      "Goronyo",
      "Gudu",
      "Gwadabawa",
      "Illela",
      "Kebbe",
      "Kware",
      "Rabah",
      "Sabon Birni",
      "Shagari",
      "Silame",
      "Sokoto-North",
      "Sokoto-South",
      "Tambuwal",
      "Tangaza",
      "Tureta",
      "Wamako",
      "Wurno",
      "Yabo",
    ],
  },

  {
    code: "TA",
    name: "Taraba",
    capital: "Jalingo",
    latitude: "8.0141333993904",
    longitude: "10.737633599999999",
    lgas: [
      "Ardo-Kola",
      "Bali",
      "Donga",
      "Gashaka",
      "Gassol",
      "Ibi",
      "Jalingo",
      "Karim-Lamido",
      "Kurmi",
      "Lau",
      "Sardauna",
      "Takum",
      "Ussa",
      "Wukari",
      "Yorro",
      "Zing",
    ],
  },

  {
    code: "YO",
    name: "Yobe",
    capital: "Damaturu",
    latitude: "12.123324199591742",
    longitude: "11.506593699999998",
    lgas: [
      "Bade",
      "Bursari",
      "Damaturu",
      "Fika",
      "Fune",
      "Geidam",
      "Gujba",
      "Gulani",
      "Jakusko",
      "Karasuwa",
      "Machina",
      "Nangere",
      "Nguru",
      "Potiskum",
      "Tarmuwa",
      "Yunusari",
      "Yusufari",
    ],
  },

  {
    code: "ZA",
    name: "Zamfara",
    capital: "Gusau",
    latitude: "12.007899799581104",
    longitude: "6.4191432",
    lgas: [
      "Anka",
      "Bakura",
      "Birnin Magaji/Kiyaw",
      "Bukkuyum",
      "Bungudu",
      "Gummi",
      "Gusau",
      "Isa",
      "Kaura-Namoda",
      "Kiyawa",
      "Maradun",
      "Maru",
      "Shinkafi",
      "Talata-Mafara",
      "Tsafe",
      "Zurmi",
    ],
  },
];

export const areas_in_lagos = [
  "Ikeja",
  "Victoria Island",
  "Surulere",
  "Lekki",
  "Ajah",
  "Ikoyi",
  "Yaba",
  "Eti-Osa",
  "Badagry",
  "Amuwo-Odofin",
  "Lagos Island",
  "Festac Town",
  "Ikeja GRA",
  "Apapa",
  "Ikorodu",
  "Epe",
  "Agege",
  "Alimosho",
  "Ifako-Ijaiye",
  "Kosofe",
  "Mushin",
  "Oshodi-Isolo",
  "Shomolu",
  "Lagos Mainland",
];

export const colorNames = [
  "Red",
  "Orange",
  "Yellow",
  "Green",
  "Turquoise",
  "Blue",
  "Purple",
  "Pink",
  "Magenta",
  "Lavender",
  "Maroon",
  "Crimson",
  "Amber",
  "Coral",
  "Teal",
  "Navy",
  "Violet",
  "Indigo",
  "Mauve",
  "Lime",
];

export let priceList = [
  "Under 20 K",
  "20 - 100 K",
  "100 - 250 K",
  "250 - 1.2 M",
  "More than 1.2 M",
];

export const categoriesList = [
  "Bedroom",
  "Outdoor",
  "Garden Supplies",
  "Home Appliances",
  "Kitchen ware",
  "Living Room",
  "Home Accessories",
  "Office",
];

export let conditionList = ["Brand New", "Used"];

export let profileDropDownDetails = [
  {
    text: "My profile ",
    url: "/Dashboard",
  },
  {
    text: "Account Settings ",
    url: "/Dashboard/AccountSettings",
  },
  {
    text: "Purchase History ",
    url: "#",
  },
  {
    text: "My Shop ",
    url: "#",
  },
  {
    text: "Payments ",
    url: "#",
  },
];

export const ProductCategory = [
  "Electonics",
  "Fashion",
  "Health & Beauty",
  "Furniture",
  "Automobiles",
  "Outdoors",
  "Foods",
];
